import { EMBLEM_IMAGE_BASE_PATH, LEAGUES } from "./constant"

export default class ConnectApp {
    /**
     * constructor
     */
    constructor(config) {
        this.isLineClubConnect = false;
    }

    /**
     * provider id 一覧を取得
     *
     * @returns {Array}
     */
    get providerIds() {
        return this._providerIds;
    }

    /**
     * provider id 一覧を設定
     *
     * @param {Array} providerIds
     */
    set providerIds(providerIds) {
        this._providerIds = providerIds;
    }

    /**
     * クラブチーム一覧を取得
     *
     * @returns {({teamName: string, clubCode: string, emblemImg: string, league: string, shortName: string}|{teamName: string, clubCode: string, emblemImg: string, league: string, shortName: string}|{teamName: string, clubCode: string, emblemImg: string, league: string, shortName: string}|{teamName: string, clubCode: string, emblemImg: string, league: string, shortName: string}|{teamName: string, clubCode: string, emblemImg: string, league: string, shortName: string})[]}
     */
    get allClubTeams() {
        return jleagueClubList.getAllClubTeams();
    }

    /**
     *
     * @returns {[]}
     */
    get lineClubConnectTeams() {
        return this._lineClubConnectTeams;
    }

    /**
     *
     * @param {Array} codes
     */
    set lineClubConnectTeams(codes) {
        const self = this;
        const clubs = [];
        codes.forEach(code => {
            const club = self.getClubTeamByClubCode(code);
            if (!!club) {
                clubs.push(club);
            }
        })
        clubs.sort(function(a, b) {
            return a.num - b.num;
        });
        this._lineClubConnectTeams = clubs;
    }

    /**
     * line 連携済みかどうか
     *
     * @returns boolean
     */
    get connectedLine() {
        return this._connectedLine;
    }

    /**
     * provider id 一覧を設定
     *
     * @param {boolean} connectedLine
     */
    set connectedLine(connectedLine) {
        this._connectedLine = connectedLine;
    }


    get lineClubConnectElements() {
        return this._lineClubConnectElements;
    }

    set lineClubConnectElements(selectorClass) {
        this._lineClubConnectElements = document.getElementsByClassName(selectorClass);
    }

    get linkAccountElements() {
        return this._linkAccountElements;
    }

    set linkAccountElements(selectorClass) {
        this._linkAccountElements = document.getElementsByClassName(selectorClass);
    }

    get lineClubConnectListElement() {
        return this._lineClubConnectListElement;
    }

    set lineClubConnectListElement(selectorId) {
        this._lineClubConnectListElement = document.getElementById(selectorId);
    }

    get lineClubConnectButtonElement() {
        return this._lineClubConnectButtonElement;
    }

    set lineClubConnectButtonElement(selectorId) {
        this._lineClubConnectButtonElement = document.getElementById(selectorId);
    }

    /**
     * クラブコードからクラブチームを取得
     *
     * @param {string} clubCode - クラブコード
     * @returns {{teamName: string, clubCode: string, emblemImg: string, league: string, shortName: string}}
     */
    getClubTeamByClubCode(clubCode) {
        const code = clubCode.toUpperCase();
        const clubObj = this.allClubTeams.find(clubTeam => clubTeam.clubCode === code);
        clubObj.num = this.allClubTeams.findIndex(clubTeam => clubTeam.clubCode === code);
        return clubObj
    }

    /**
     * LINEクラブ公式アカウント連携用のHTMLを表示する
     */
    renderLineClubConnectElement() {
        const self = this;
        const target = this.lineClubConnectListElement;

        // リーグごとに分けて表示する
        LEAGUES.forEach(league => {
            const clubTeams = self.lineClubConnectTeams.filter(clubTeam => {
                return clubTeam.league === league;
            });

            if (clubTeams.length) {
                target.appendChild(ConnectApp.createLineClubConnectSection(league, clubTeams));
            }
        });
        if (this.connectedLine) {
            const element = document.createElement('section');
            element.classList.add('line-club-connect');
            element.insertAdjacentHTML('afterbegin', `<h2 class="line-club-connect__header">Ｊリーグ</h2><p id="line-unregist">他サイトアカウント連携の「LINE連携」も解除されます。<br>LINEアカウントでＪリーグIDをご利用中の場合は、再度連携いただくまでログインできなくなりますのでご注意ください。</p>`);
            const ul = document.createElement('ul');
            ul.classList.add('clubList');
            ul.classList.add('line-club-connect__list');
            const csrf_token = document.getElementById("csrf_token").value;
            const li = [];

            var action_uri = '/connect/line';
            var form_id = 'connect_form_line';
            var button_id = 'line_tap_unregist';
            var image_src = EMBLEM_IMAGE_BASE_PATH + "embJleagueLogo.png";
            var label = "Ｊリーグ"
            li.push(
                ConnectApp.createLineClubConnectHtmlLi(action_uri, form_id, button_id, csrf_token, image_src, label)
            );

            ul.insertAdjacentHTML('beforeend', li.join(''));
            element.insertAdjacentHTML('beforeend', ul.outerHTML);

            target.appendChild(element);
        }
    }

    /**
     * リーグ単位でクラブチーム一覧用のHTMLを構築する
     *
     * @param {string} league
     * @param {Array} clubTeams
     * @returns {HTMLElement}
     */
    static createLineClubConnectSection(league, clubTeams) {
        const element = document.createElement('section');
        element.classList.add('line-club-connect');
        element.insertAdjacentHTML('afterbegin', `<h2 class="line-club-connect__header">${league}</h2>`);
        element.insertAdjacentHTML('beforeend', ConnectApp.createLineClubConnectList(clubTeams).outerHTML);

        return element;
    }

    /**
     * クラブチーム一覧用のHTMLを構築する
     *
     * @param {Array} clubTeams
     * @returns {HTMLUListElement}
     */
    static createLineClubConnectList(clubTeams) {
        const ul = document.createElement('ul');
        ul.classList.add('clubList');
        ul.classList.add('line-club-connect__list');
        const csrf_token = document.getElementById("csrf_token").value;
        const li = [];
        clubTeams.forEach(clubTeam => {
            var action_uri = '/connect/line-id-' + clubTeam.clubCode.toLowerCase();
            var form_id = 'connect_form_' + clubTeam.clubCode.toLowerCase();
            var button_id = 'line_tap_' + clubTeam.clubCode.toLowerCase() + '_unregist';
            var image_src = EMBLEM_IMAGE_BASE_PATH + clubTeam.emblemImg;
            li.push(
                ConnectApp.createLineClubConnectHtmlLi(action_uri, form_id, button_id, csrf_token, image_src, clubTeam.teamName)
            );
        });
        ul.insertAdjacentHTML('beforeend', li.join(''));

        return ul;
    }

    /**
     *
     * @param action_uri {string}
     * @param form_id {string}
     * @param button_id {string}
     * @param csrf_token {string}
     * @param image_src {string}
     * @param label {string}
     * @returns {string}
     */
    static createLineClubConnectHtmlLi(action_uri, form_id, button_id,csrf_token,image_src,label){
        return `
                    <li>
                        <form id="${form_id}" method="post" action="${action_uri}">
                            <input type="hidden" name="_csrf" value="${csrf_token}"/>
                            <input type="hidden" name="_method" value="DELETE" />
                            <div class="club-team">
                                <img src="${image_src}" alt="${label}">
                                ${label}
                                <div class="remove-button">
                                    <label>解除
                                        <input 
                                            data-teamname="${label}" 
                                            data-name="${form_id}" 
                                            data-button="${button_id}"
                                            type="checkbox" 
                                            name="" value="" checked>
                                    </label>
                                    <button class="remove-line-button" onclick="return false;" id="${button_id}"></button>
                                </div>
                            </div>
                        </form>
                    </li>
                `
    }

    /**
     * provider ID一覧からクラブコードを取得
     *
     * @param {Array} providerIds
     * @returns {Array}
     */
    static getClubTeamCodesByProviderIds(providerIds) {
        const regexp = /^line-id-([a-zA-Z]{2}$)/;
        const _providerIds = [];

        providerIds.forEach(providerId => {
            const _id = this.getClubTeamCodesByProviderId(providerId);
            if (_id !== null) {
                _providerIds.push(_id);
            }
        });

        return _providerIds;
    }

    /**
     * provider ID一覧クラブコードを取得
     *
     * @param {String} providerId
     * @returns {String}
     */
    static getClubTeamCodesByProviderId(providerId) {
        const regexp = /^line-id-([a-zA-Z]{2}$)/;

        const matches = providerId.match(regexp);
        if (!!matches) {
            return matches[1]
        }
        return null;
    }

    /**
     * 表示を切り替える
     */
    toggleHtmlView() {
        this.isLineClubConnect = !this.isLineClubConnect;

        const display = (this.isLineClubConnect)? {linkAccount: 'none', lineClubConnect: 'block'}: {linkAccount: 'block', lineClubConnect: 'none'};
        Array.prototype.forEach.call(this.linkAccountElements, element => {
            element.style.display = display.linkAccount;
        });

        Array.prototype.forEach.call(this.lineClubConnectElements, element => {
            element.style.display = display.lineClubConnect;
        });

        document.title = "ＪリーグID | LINE公式アカウント連携"
        window.scrollTo(0, 0);
    }

    /**
     * LINEクラブ公式アカウント連携ボタンにイベントを追加
     */
    addLineClubConnectButtonEvent() {
        if (!this.lineClubConnectButtonElement) return;

        this.lineClubConnectButtonElement.addEventListener('click', () => {
            this.toggleHtmlView();
        });
    }

    /**
     * 解除ボタンを押下したときの処理
     */
    addRemoveButtonEvent() {
        const removeButtons = this.lineClubConnectListElement.querySelectorAll('.remove-button input');
        if (!removeButtons.length) return;
        removeButtons.forEach(element => {
            element.addEventListener('click', () => {
                let teamName = element.dataset.teamname;
                if (window.confirm(teamName + 'のLINE公式アカウント連携を解除します。\nよろしいですか？')) {
                    const form = document.getElementById(element.dataset.name);
                    const button = document.getElementById(element.dataset.button);
                    if(button) {
                        button.click();
                    }
                    localStorage.setItem('line_club_connect', 'true');
                    form.submit();
                }
            })
        })
    }

    ready() {
        this.renderLineClubConnectElement();
        this.addLineClubConnectButtonEvent();
        this.addRemoveButtonEvent();
    }
};
